
window.addEventListener('DOMContentLoaded', (event) => {

  // === Modal Global functions

  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  });

  function openModal(modal) {
    if (modal !== null && modal !== undefined) {
      modal.classList.toggle('active');
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}`;
    }
  }

  function closeModal(modal) {
    if (modal !== null && modal !== undefined) {
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo({
        left: 0,
        top: parseInt(scrollY || '0') * -1,
        behavior: 'instant'
      });
      modal.classList.toggle('active');
    }
  }
  
  // === Modal media list

  const modalMediaList = document.querySelector('[data-modal-media-list]');

  if (modalMediaList !== null && modalMediaList != undefined) {

    const mediaListToggle = document.querySelectorAll('[data-media-list-toggle]');
    if (mediaListToggle.length > 0) {
      mediaListToggle.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (modalMediaList.classList.contains('active')) {
            closeModal(modalMediaList);
          } else {
            openModal(modalMediaList);
          }

        });
      });
    }
    
  }

  // === Modal media slider

  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active")
        })
      }
      function addActive(idx) {
        slider.slides[idx].classList.add("active")
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx)
          })
        })
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel)
        addClickEvents()
        main.on("animationStarted", (main) => {
          removeActive()
          const next = main.animator.targetIdx || 0
          addActive(main.track.absToRel(next))
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
        })
      })
    }
  }

  const mediaSlider = new KeenSlider("#media-slider", {
    loop: false,
    slides: {
      origin: "center",
      perView: 1,
      spacing: 32
    }
  }, [keenNav]);

  const mediaThumbnails = new KeenSlider(
    "#media-slider-thumbnails",
    {
      initial: 0,
      breakpoints: {
        "(min-width: 1100px)": {
          slides: {
            perView: 7,
            spacing: 16
          }
        }
      },
      slides: {
        perView: 4,
        spacing: 16,
      },
    },
    [ThumbnailPlugin(mediaSlider)]
  );

  const modalMediaSlider = document.querySelector('[data-modal-media-slider]');

  if (modalMediaSlider !== null && modalMediaSlider != undefined) {

    const mediaSliderToggle = document.querySelectorAll('[data-media-slider-toggle]');
    if (mediaSliderToggle.length > 0) {
      mediaSliderToggle.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (modalMediaSlider.classList.contains('active')) {
            modalMediaSlider.classList.toggle('active');
          } else {

            // Go to selected slide
            const slideIndex = button.getAttribute('data-media-slider-toggle');
            if (slideIndex !== null && slideIndex !== undefined) {
              mediaSlider.moveToIdx(parseInt(slideIndex), true, { duration: 0 });
            }

            modalMediaSlider.classList.toggle('active');

          }

        });
      });
    }
    
  }

});
